var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-repeater',{attrs:{"count":5}},[_c('div',{staticClass:"shimmer h-3 radius-2 w-7"}),_c('div',{staticClass:"shimmer h-5 mt-1 radius-2 mb-3"})])}
var staticRenderFns = []

export { render, staticRenderFns }